import { default as enGB } from './en-GB.json'
import { default as cyGB } from './cy-GB.json'

// https://kazupon.github.io/vue-i18n/guide/datetime.html
export default {
  'en-GB': enGB,
  'cy-GB': cyGB
}
